import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";

const dryLeafDescriptions = {
  "Rosemary Dry Leaves": `Experience the natural goodness of Aranya Nutraceuticals Rosemary Dry Leaves, carefully selected and hygienically packed to preserve their rich aroma and quality. Made from 100% natural rosemary leaves with no added chemicals or artificial ingredients, our premium dried rosemary is ideal for creating a nourishing rosemary water rinse or an infused hair oil as part of your hair care routine.`,

  "Basil Dry Leaves": `Discover the aromatic essence of Aranya Nutraceuticals Basil Dry Leaves, meticulously processed to maintain their vibrant flavor and therapeutic properties. Perfect for culinary applications and traditional medicine, our premium basil leaves offer a delightful taste and numerous health benefits.`,
};

const DryLeavesDescription = () => {
  const { state } = useLocation();

  const navigate = useNavigate();

  // Browser tab title fix
  useEffect(() => {
    if (state?.name) {
      document.title =
        `${state.name} Supplier | Aranya Nutraceuticals`;
    } else {
      document.title =
        "Product Not Found | Aranya Nutraceuticals";
    }
  }, [state]);

  // If state missing
  if (!state) {
    return (
      <>
        <Helmet>
          <title>
            Product Not Found | Aranya Nutraceuticals
          </title>

          <meta
            name="description"
            content="Requested product page not found."
          />
        </Helmet>

        <div className="p-10">
          <p>Product not found</p>
        </div>
      </>
    );
  }

  const description =
    dryLeafDescriptions[state.name?.trim()] ||
    "High-quality dried leaves available for industrial and bulk supply requirements.";

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>
          {state.name} Supplier | Aranya Nutraceuticals
        </title>

        <meta
          name="description"
          content={`${state.name} supplier in India for cosmetic, wellness, and industrial applications. Premium quality bulk supply with reliable sourcing and packaging.`}
        />

        <meta
          name="keywords"
          content={`${state.name}, dry leaves supplier, herbal products, bulk supply`}
        />

        <meta
          property="og:title"
          content={`${state.name} Supplier | Aranya Nutraceuticals`}
        />

        <meta
          property="og:description"
          content={`Premium quality ${state.name} supplier for cosmetic and wellness formulations.`}
        />

        <meta
          property="og:image"
          content={state.img}
        />

        <meta property="og:type" content="website" />
      </Helmet>

      <div className="min-h-screen px-4 md:px-10 py-8 md:py-12 bg-gray-50">

        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="mb-6 text-green-600 hover:underline"
        >
          ← Back
        </button>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-start">

          {/* Image */}
          <img
            src={state.img}
            alt={state.name}
            loading="eager"
            width="600"
            height="400"
            className="w-full h-72 md:h-[400px] object-cover rounded shadow"
          />

          {/* Content */}
          <div>

            <h1 className="text-2xl md:text-3xl font-bold mb-4">
              {state.name}
            </h1>

            <p className="text-gray-700 leading-relaxed text-sm md:text-base">
              {description}
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default DryLeavesDescription;